import { objectOf, arrayOf, anyOf } from "@altostra/type-validations";
import { string, number, nullValidation } from "@altostra/type-validations/lib/primitives";

export const isEngagementAppGroupIdLibraryReplaceFileResult = objectOf({
  info: string,
  new_image_asset: objectOf({
    id: string,
    created_at: number,
    name: string,
    size: number,
    territory_ids: arrayOf(string),
    app_group_id: string,
    ext: anyOf(string, nullValidation),
    created_by: anyOf(string, nullValidation),
    last_edited_by: anyOf(string, nullValidation),
    url: string,
    type: string,
    known_width: anyOf(number, nullValidation),
    known_height: anyOf(number, nullValidation),
    ratio: anyOf(number, nullValidation),
    src: anyOf(string, nullValidation),
  }),
});
